import React, { useEffect, useState } from 'react'
import Button from '../../../../Button'
import Column from '../../../../Column'
import { Value } from '../../Media/MediaItem/MediaItem.style'
import { PromoItemDom, ValueGroup } from './PromoItem.style'
import { RemoveIcon } from '../MultiMedia/Media.style'
import { withTranslation } from 'react-i18next'
import Padding from '../../../../Padding'
import Input from '../../../../Input'
import { ObjectUtils } from '../../../../../utils'
import Link from '../../../../Link'
import { validate } from './promoValidation'
import { connect } from 'react-redux'
import { updateMedia as actionUM } from '../../../../../actions/content/media'
import { detachMediaFromChannel as actionDMC } from '../../../../../actions/content/channels'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import Form from '../../../../Form'
import Thumbnail from '../../../../Thumbnail'

const { Label } = Form

const PromoItem = ({ promo, updateMedia, closeModal, detachMediaFromChannel, channelId, t, restartAfterDelete }) => {
    const { date_end: currentDateEnd, date_start: currentDateStart, id, name } = promo

    const [dateEnd, setDateEnd] = useState(currentDateEnd)
    const [dateStart, setDateStart] = useState(currentDateStart)
    const [formErrors, setFormErrors] = useState({})

    const { date_end: errorDateEnd, date_start: errorDateStart } = formErrors

    useEffect(() => {
        setDateEnd(currentDateEnd)
    }, [currentDateEnd])

    useEffect(() => {
        setDateStart(currentDateStart)
    }, [currentDateStart])

    // Build form value
    const buildForm = () => ({
        date_end: dateEnd,
        date_start: dateStart,
        id,
        name,
    })

    /**
     * On Submit whole form
     */
    const onSubmit = async () => {
        const form = buildForm()
        let errors = validate(form)
        setFormErrors(errors)

        if (!ObjectUtils.isObjValuesEmpty(errors)) {
            return false
        }

        await updateMedia(form)
        closeModal()
    }

    /**
     * Render Start Date label
     */
    const renderStartDateLabel = () => (
        <>
            {t('date-start')}
            &nbsp;
            <Link onClick={() => setDateStart(null)}>&times;</Link>
        </>
    )

    /**
     * Render End label
     */
    const renderEndDateLabel = () => (
        <>
            {t('date-end')}
            &nbsp;
            <Link onClick={() => setDateEnd(null)}>&times;</Link>
        </>
    )

    /**
     * On remove media button click
     * @param {Object} e
     */
    const onRemoveClick = (e) => {
        if (typeof e.stopPropagation === 'function') {
            e.stopPropagation()
        }
        detachMediaFromChannel(channelId, id)
        restartAfterDelete()
    }

    return (
        <PromoItemDom>
            <Column
                width="100%"
                style={{
                    textAlign: 'center',
                    overflowY: 'hidden',
                    position: 'absolute',
                    marginLeft: '10px',
                }}
            >
                <Column
                    style={{
                        overflowY: 'hidden',
                        width: '20%',
                    }}
                >
                    <Thumbnail mediaId={promo.id} media={promo} />
                </Column>
                <Column
                    style={{
                        overflowY: 'hidden',
                        width: '40%',
                    }}
                >
                    <Padding fullHeight>
                        <ValueGroup nomargin>
                            <Label>{`${t('file-name')}:`}</Label>
                            <Value>{name}</Value>
                        </ValueGroup>
                        <ValueGroup>
                            {!!dateStart && (
                                <Label id="date_start" label={renderStartDateLabel()} error={errorDateStart}>
                                    <Input
                                        id="date_start"
                                        name="date_start"
                                        type="date"
                                        error={!!errorDateStart}
                                        onChange={(date) => setDateStart(new Date(date).getTime())}
                                        value={dateStart}
                                        withTime
                                    />
                                </Label>
                            )}
                            {!dateStart && (
                                <div>
                                    <Link onClick={() => setDateStart(currentDateEnd || new Date().getTime())}>{t('date-start-add')}</Link>
                                </div>
                            )}
                        </ValueGroup>
                    </Padding>
                </Column>
                <Column
                    style={{
                        overflowY: 'hidden',
                        width: '40%',
                    }}
                >
                    <Padding>
                        <ValueGroup nomargin>
                            <Button theme="danger" radius="5" onClick={onRemoveClick}>
                                <RemoveIcon />
                            </Button>
                            <Button icon="save" iconSize="lg" theme="secondary" radius={5} size="xs" padding="6px" onClick={onSubmit}>
                                {t('Save')}
                            </Button>
                        </ValueGroup>
                        <ValueGroup nomargin>
                            {!!dateEnd && (
                                <Label label={renderEndDateLabel()} error={errorDateEnd}>
                                    <Input
                                        id="date_end"
                                        name="date_end"
                                        type="date"
                                        error={!!errorDateEnd}
                                        onChange={(date) => setDateEnd(new Date(date).getTime())}
                                        value={dateEnd}
                                        withTime
                                    />
                                </Label>
                            )}
                            {!dateEnd && (
                                <div>
                                    <Link onClick={() => setDateEnd(currentDateEnd || new Date().getTime())}>{t('date-end-add')}</Link>
                                </div>
                            )}
                        </ValueGroup>
                    </Padding>
                </Column>
            </Column>
        </PromoItemDom>
    )
}

PromoItem.propTypes = {
    promo: PropTypes.shape({
        date_end: PropTypes.number,
        date_start: PropTypes.number,
        id: PropTypes.number,
        name: PropTypes.string,
    }),
    channelId: PropTypes.number,
    t: PropTypes.func.isRequired,
    updateMedia: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    detachMediaFromChannel: PropTypes.func.isRequired,
    restartAfterDelete: PropTypes.func.isRequired,
}

PromoItem.defaultProps = {
    promo: {},
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateMedia: actionUM,
            detachMediaFromChannel: actionDMC,
        },
        dispatch
    )

export default connect(null, mapDispatchToProps)(withTranslation()(PromoItem))
